import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-trip-list',
  templateUrl: './trip-list.component.html',
  styleUrls: ['./trip-list.component.css']
})
export class TripListComponent implements OnInit {

  @Input() titleString: string;
  @Input() subtitleString: string;
  @Input() headerColor: string;
  @Input() hasTextShadow: boolean;
  @Input() entries: TripEntry[];
  @Input() height?: string;

  constructor() {
    this.titleString = '<TODO>';
    this.subtitleString = '<TODO>';
    this.headerColor = 'primary';
    this.hasTextShadow = false;
  }

  ngOnInit() {
  }

}

export class TripEntry {
  constructor(options?: { title: string; route: string; iconName?: string; }) {
      if (options) {
          this.title = options.title;
          this.route = options.route;
          if (options.iconName) {
            this.iconName = options.iconName;
          }
      }
  }
  title: string;
  route: string;
  iconName: string;
}
